<template>
  <div class="countdown-wrap">
    <ul>
      <li><p class="countdown-num">{{day}}</p><span>天</span></li>
      <li><p class="countdown-num">:</p></li>
      <li><p class="countdown-num">{{hour}}</p><span>小时</span></li>
      <li><p class="countdown-num">:</p></li>
      <li><p class="countdown-num">{{minute}}</p><span>分钟</span></li>
      <li><p class="countdown-num">:</p></li>
      <li><p class="countdown-num">{{second}}</p><span>秒</span></li>
    </ul>
    <p class="countdown-title">
      <span>活动结束倒计时</span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      day: '00',
      hour: '00',
      minute: '00',
      second: '00',
    };
  },
  props: {
    startTime: String,
  },
  mounted() {
    this.showTime();
    this.timer = setInterval(this.showTime, 100);
  },
  methods: {
    showTime() {
      const sT = new Date(this.startTime);
      const nT = new Date();
      const dT = sT - nT;
      if (dT < 0) {
        clearInterval(this.timer);
        return;
      }
      const d = parseInt(dT / 1000 / 60 / 60 / 24, 10);
      const h = parseInt((dT / 1000 / 60 / 60) % 24, 10);
      const m = parseInt((dT / 1000 / 60) % 60, 10);
      const s = parseInt((dT / 1000) % 60, 10);
      this.day = this.changeTime(d);
      this.hour = this.changeTime(h);
      this.minute = this.changeTime(m);
      this.second = this.changeTime(s);
    },
    changeTime(v) {
      return v < 10 ? `0${v}` : `${v}`;
    },
  },
};
</script>

<style>
.countdown-wrap{
  padding-top: 2%;
}
.countdown-wrap ul{
  display: flex;
  justify-content: center;
  color: #fff;
  border: 1px solid #fff;
  margin: 0 2.5%;
  padding: 2% 0;
}
.countdown-wrap li{
  text-align: center;
  padding: 2px;
}
.countdown-wrap ul span{
  font-size: 14px;
}
.countdown-num{
  font-size: 44px;
  line-height: 1em;
}
.countdown-title{
  color: #fff;
  text-align: center;
  font-size: 16px;
  padding: 2% 0;
}
.countdown-title span{
  line-height: 1.4em;
  padding-left: 1.5em;
  background: url(//res.aidalan.com/hd/sg/img/time.png) no-repeat;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/Countdown.vue